export enum RenewableSubsidyApplicationProvider {
    AGL = 'AGL',
    QCELLS = 'QCELLS',
    SONNEN = 'SONNEN'
}
